/**
 * @description 内部添零函数
 * @param { Number } number
 * @author yangmm
 * @createdTime 2023/8/14 9:25
 */
export const addZero = (number) => {
    return number > 9 ? number : `0${number}`
}
/**
 * 计算表格高度
 * @param { String } ref 组件绑定值,切勿出现同一名称
 * @param { Number } rectifyNum 修正数值
 */
export const getTableHeight = async function(ref = 'table', rectifyNum = 0, cb) {
    function delayt() { return true }
    let a = await delayt();
    const dom = this.$refs[ref] && this.$refs[ref].$el;
    if (!dom) return false
    const { top } = dom.getBoundingClientRect(); // 获取元素到窗口的距离
    this.$refs[ref].height = window.innerHeight - top - 82 + rectifyNum;
    cb && cb(window.innerHeight - top - 82 + rectifyNum);
    return window.innerHeight - top - 82 + rectifyNum; // 82 包含分页及内外边距 根据使用场景使用rectifyNum进行修正
}

/**
 * @description 获取屏幕缩放比例  探针、测距、标签功能都需要
 * @returns { Number } ratio
 * @author yangmm
 * @createdTime 2023/8/22 14:40
 */
export const getScreenRatio = () => {
    let ratio = 0
    let screen = window.screen
    let ua = navigator.userAgent.toLowerCase()
    if (window.devicePixelRatio !== undefined) {
        ratio = window.devicePixelRatio
    } else if (~ua.indexOf('msie')) {
        if (screen.deviceXDPI && screen.logicalXDPI) {
            ratio = screen.deviceXDPI / screen.logicalXDPI
        }
    } else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
        ratio = window.outerWidth / window.innerWidth
    }
    if (ratio) {
        ratio = Math.round(ratio * 100)
    }
    return ratio
}
/**
 * @description 获取隐藏手机号码中间4位数改为*
 * @param { String } phone 手机号
 * @returns { String } string 返回新手机号
 * @author yangmm
 * @createdTime 2022/10/27 15:10
 */
export const getHideTel = (phone = '') => {
    const start = phone.substring(0, 3)
    const end = phone.substring(phone.length - 4)
    return phone ? `${start}****${end}` : phone
}

/**
 * @description 获取隐藏邮箱@字符前和interval后位数改为*
 * @param { String } email 邮箱地址
 * @param { Number } interval 起始分割位
 * @returns { String } 返回新邮箱
 * @author yangmm
 * @createdTime 2022/10/27 16:25
 */
export const getHideEmail = (email = '', interval = 4) => {
    let index = email.indexOf('@')
    let start = email.substring(0, index)
    let end = email.substring(index)
    let str = '',
        len = start.length,
        max = len - interval
    if (max > 0) {
        for (let i = 0; i < max; i++) {
            str += '*'
        }
        return `${start.substring(0, interval)}${str}${end}`
    }
    return email
}
/**
 * @description 导出下载excel 文件
 * @param { Object } response 后台响应数据
 * @param { String } name 前端自定义文件名 非必要    
 * @author zengxl
 * @createTime 2021-02-23 17:18:53
 */

export const Down = (response, name = null) => {

    // 错误 停止下载
    if (!response.headers["content-disposition"]) {
        // 将blob对象解析为json DOMString 对象
        ParseBlobData(response.data)

        return
    }

    // 创建Blob对象
    const blob = new Blob([response.data])

    // 利用decodeURIComponent()方法解码出后台传过来的文件名
    const _fileNme = decodeURIComponent(response.headers["content-disposition"].split(";")[1].split("filename=")[1])

    // 获取后缀名
    const suffix = _fileNme.split('.')[1]

    // 有自定义名字则 使用自定义名字加上后缀作为文件名，没有则使用解析出来的文件名
    const fileName = name ? `${name}.${suffix}` : _fileNme

    if ('download' in document.createElement('a')) { // 非IE下载
        // 创建a标签DOM对象
        const dom = document.createElement('a')

        // 设置a标签属性
        dom.download = fileName
        dom.style.display = 'none'
        // 创建包含一个表示参数中给出的对象的URL
        dom.href = URL.createObjectURL(blob)

        // 加入body
        document.body.appendChild(dom)

        // 触发a标签事件
        dom.click()

        // 释放URL 对象
        URL.revokeObjectURL(dom.href)

        // 从body移除该a标签
        document.body.removeChild(dom)

    } else { // IE10+下载
        navigator.msSaveBlob(blob, fileName)
    }
}

/**
 * @description 解析Blob数据 主要用于错误信息提示
 * @param { Blob } data 后台返回的Blob对象
 * @param { Boolean } flag 标识是否取消重复请求 默认false
 */
export const ParseBlobData = (data, flag = false) => {
    // 将blob对象解析为json DOMString 对象
    if (data.type == 'application/json') {
        // 创建文件读取对象
        const reader = new FileReader()
        // onload 是异步方法 after
        reader.onload = e => {
            if (e.target.readyState === 2) {
                // 获取错误信息对象
                const error = JSON.parse(e.target.result)

                if (!flag || (flag && !error.isCancel))
                    vm.$Message.error(error.message)
            }
        }
        // before 位置必须在onload后面 
        // 将 Blob 或者 File 对象转根据特殊的编码格式转化为内容(字符串形式)
        reader.readAsText(data)
    }

    if (flag) {
        vm.$Message.error(data.message)
    }
}

/**
 *  计算文件大小
 * @param e
 * @returns {number}
 */
export const calculateFileSize = (size) => {
    const B = 1024
    const KB = Math.pow(1024, 2)
    const MB = Math.pow(1024, 3)
    const GB = Math.pow(1024, 4)
    if (!size) {
        return '_'
    } else if (size < B) {
        return size + 'B'
    } else if (size < KB) {
        return (size / B).toFixed(0) + 'KB'
    } else if (size < MB) {
        return (size / KB).toFixed(1) + 'MB'
    } else if (size < GB) {
        return (size / MB).toFixed(2) + 'GB'
    } else {
        return (size / GB).toFixed(3) + 'TB'
    }
}
/**
 *  获取字典多语言key
 * @param e
 * @returns {number}
 */
export const getdic = (item) => {
    if (localStorage.getItem('locale') == 'en-US') {
        return item.dict_value.en_name || item.dict_value.name;
    } else {
        return item.dict_value.name
    }
}
/**
 *  获取字典标签值
 * @param e
 */
export const getLabel = function(v, type) {
    if (type == 'taskList' || type == 'specificTaskList') { //多选
        let arr = this[type].filter(item => v.includes(item.dict_value.identify));
        return arr.map(item => getdic(item)).join('、')||'unknown';
    } else {
        let arr = this[type].filter(item => v == item.dict_value.identify);
        return arr.length && getdic(arr[0])||'unknown';
    }
}
/**
 *  判断对象是否有空值
 * @param e
 */
export const checkObj = (obj, arr=[]) => {
    let flag = false;
    Object.keys(obj).forEach(key => {
        if(!arr.includes(key)){
            if(!obj[key]){
                flag = true;
            }
        }
    });
    return flag;
}



/**
 * @description 初始化请求查询参数
 * @param { Object } params 对象
 * @returns { Object } 对象
 */
export const initQueryParams = (params) => {
    const defParams = {
        page: 1,
        size: 10
    }
    return params ? { ...defParams, ...params } : defParams;
}


/**
 * @description 单个数组对象去重
 * @param { Array } arr 源数据
 * @param { String } id 唯一标识
 * @returns { Array } 返回去重后的数组
 */
export const singleRepeat = (arr = [], id = 'id') => {
    return arr.reduce((cur, next) => cur.some(el => (id ? el[id] : el) === (id ? next[id] : next)) ? cur : [...cur, next], [])
}

/**
 * @description 文件上传类型
 * @param { String } type 类型
 * @param { Array } params 其它参数
 * @returns { Array } 返回去重后的数组
 */
export const fileMultiType = (type = '', params = []) => {
    const image = ['png', 'jpg', 'jepg', 'webp', 'bmp', 'gif', 'jfif', 'svs', 'tiff', 'tif']
    const file = ['txt', 'pdf']

    switch (type) {
        case 'image':
            return [...image, ...params]
        case 'file':
            return [...file, ...params]
        default:
            return [...image, ...file, ...params]
    }
}

/**
 * @description 获取数组中值的名称
 * @param { Array } list 源数组
 * @param { String } value 值
 * @param { String } id 唯一标识
 * @param { String } label key值
 * @returns { String } 数组名称
 */
export const getArrayName = (list = [], value = '', id = 'value', label = 'label') => {
    const arr = list.filter(d => d[id] === value)
    return arr.length ? arr[0][label] : ''
}


/**
 * @description 同名参数赋值
 * @param { Object } arrA 源对象
 * @param { Object } arrB 比较对象
 * @returns { Object } 对象
 */
export const listAssign = (arrA, arrB) => {
    Object.keys(arrA).forEach(key => {
        arrA[key] = arrB[key]
    })
    return arrA
}

/**
 * @description 判断是否为数组
 * @param { Array } arr 数组
 * @returns { Boolean } 返回最新值
 */
export const isArray = (arr) => {
    return typeof arr === "object" && Array.isArray(arr);
}

/**
 * @description 判断对象是否为空
 * @param { Object } obj 对象
 * @returns { Boolean } 返回最新值
 */
export const isEmptyObject = (obj) => {
    return Object.keys(obj).length === 0;
}

/**
 * @description 更新对象未定义的值
 * @param { Object } obj 对象
 * @param { String | Array } str 删除的key
 * @returns { Object } 返回最新值
 */
export const updateObjEmpty = (obj, str = '') => {
    for (let item in obj) {
        const node = obj[item]
        const string = typeof node === 'string'
        const number = typeof node === 'number'
        if ((string && (!node || node === '-1')) || node === undefined) {
            obj[item] = ''
        }
        if (number && node === undefined || node === -1) {
            obj[item] = null
        }

        if (str) {
            // 字符串时
            if (typeof str === 'string' && item === str) {
                delete obj[str]
            }

            // 数组时
            if (isArray(str)) {
                str.forEach(el => {
                    if (el === item) {
                        delete obj[item]
                    }
                })
            }
        }
    }
    return obj
}


/**
 * @description 获取异步数据方法
 * @param { Function } cb 方法
 * @returns { Promise } 异步数据获取回调函数
 */
let awaitTimer = [];
let awaitIndex = 0;
export const getWait = (cb) => {
    let current = awaitIndex++;
    return new Promise((resolve, reject) => {
        awaitTimer[current] = setInterval(() => {
            let a = cb();
            if (a) {
                resolve(true);
                clearInterval(awaitTimer[current]);
            }
        }, 100)
    })
}


/**
 * @description 某个菜单下的列表操作权限
 * @param { Array } operate 列表操作数据
 * @param { String } menuName 菜单名称
 * @returns { Array } 返回按钮数组
 */
export const cusPermissionData = (operate, menuName) => {
    const newArr = []
    const arr = [...operate]
    const permission = LocalStore.get('permissionArr') || {}
    const btnList = permission && permission[menuName] || []
    arr.forEach(el => {
        const node = !Global.openDevMenu ? btnList.find(e => e === el.permission) : true
        node && newArr.push({ ...el })
    })
    return newArr
}